import React from 'react';
import { PageHeader } from '../../components/website/pageHeader';

function Regulators() {
    return (
        <div className="bg-[#f3f3f3] font-nunito min-h-screen">
            <PageHeader 
                text="Regulators"
                subtext=""
                image={"./img/homepage/fleet.png"}
            />
        </div>
    );
}

export default Regulators;  